import React, { useEffect, useRef, useState } from "react";
import "./userInformationModal.scss";
import RightIcon from "../../../assets/icons/right-blue.svg";
import Icon1 from "../../../assets/icons/icon.svg";
import DeleteIcon from "../../../assets/icons/Delete.svg";
import BoxIcon from "../../../assets/icons/box.svg";
import UserIcon from "../../../assets/icons/user.svg";
import MarkIcon from "../../../assets/icons/user-check.svg";
import CrossIcon from "../../../assets/icons/user-x.svg";
import AddValidity from "../addValidity";
import AccountUpgrade from "../accountUpgrade";
import Delete from "../../Toaster/Delete";
import { ApiGet, ApiPost, ApiPut } from "../../../helpers/API/ApiData";
import Success from "../../Toaster/Success/Success";
import moment from "moment";
import Features from "../features";
import Auth from "../../../helpers/Auth";

import WhatsappIcon from "../../../assets/icons/whatsapp-blue.svg";
import CalendarIcon from "../../../assets/icons/calendar-blue.svg";
import AddWhatsaooValidity from "./addWhatsaooValidity";
import WhatsappPayment from "./whatsappPayment";
import Skeleton from "react-loading-skeleton";
import AcceptDeny from "../../Toaster/AcceptDeny";
import Loader from "../../common/Loader";
import { useExcelDownload } from "../../../utils/useExcelDownload";
import ImportInventoryModal from "../importInventory/ImportInventoryModal";

export default function UserInformationModal(props) {
  const { toggle, userDetails, EdituserModal } = props;
  const downloadExcel = useExcelDownload();
  let userInformation = Auth.getUserDetail();
  const [addValidityModal, setAddValidityModal] = useState(false);
  const [accountUpgradeModal, setAccountUpgradeModal] = useState(false);
  const [featuresModal, setFeaturesModal] = useState(false);
  const [whatsappValidityModal, setWhatsappValidityModal] = useState(false);
  const [whatsappPaymentDataModal, setWhatsappPaymentDataModal] =
    useState(false);

  const [editData, setEditdata] = useState();
  const [deleteData, setDeleteData] = useState();
  const [activeData, setActiveData] = useState();
  const [openDeletemodal, setOpenDeletemodal] = useState(false);
  const [totalAppointment, setTotalAppointment] = useState(0);
  const [todayAppointment, setTodayAppointment] = useState(0);
  const [totalCustomer, setTotalCustomer] = useState(0);
  const [totalInvoice, setTotalInvoice] = useState(0);
  const [managername, setManagername] = useState(0);
  const [success, setSuccess] = useState(false);
  const [toastmsg, setToastmsg] = useState();
  const [er, setEr] = useState();
  const [tinyUrl, setTinyUrl] = useState("");
  const [whatsappConnectivityStatus, setWhatsappConnectivityStatus] =
    useState("");
  const [whatsappPaymentStatus, setWhatsappPaymentStatus] = useState("");
  const [whatsappRemainingDays, setWhatsappRemainingDays] = useState(0);
  const [whatsappPlan, setWhatsappPlan] = useState();
  const [isLoading, setisLoading] = useState(false);
  const [featuresData, setFeaturesData] = useState({});
  const [smsService, setSMSService] = useState(false);
  const [smsServiceSure, setSMSServiceSure] = useState(false);
  const [transactionMessage, setTransactionMessage] = useState(false);
  const [transactionMessageSure, setTransactionMessageSure] = useState(false);
  const transactionMessagePreviousRef = useRef(false);
  const transactionMessagePendingRef = useRef(false); // intended value when user confirms
  const [settingId, setSettingId] = useState("");
  const [importInventoryModal, setImportInventoryModal] = useState(false);
  const [featuresLists, setFeaturesLists] = useState([
    {
      name: "Appointments",
      slug: "appointment",
      isChecked: true,
      type: "basic",
    },
    { name: "Invoices", slug: "invoice", isChecked: true, type: "basic" },
    { name: "Inventory", slug: "inventory", isChecked: true, type: "basic" },
    {
      name: "Customer profile",
      slug: "customerProfile",
      isChecked: true,
      type: "basic",
    },
    {
      name: "Customer wallet",
      slug: "customerWallet",
      isChecked: true,
      type: "basic",
    },
    {
      name: "Staff profile",
      slug: "staffProfile",
      isChecked: true,
      type: "basic",
    },
    { name: "Staff attendance", slug: "staff", isChecked: true, type: "basic" },
    { name: "SMS, Notifications", slug: "sms", isChecked: true, type: "basic" },
    {
      name: "Statement, Daily reports",
      slug: "statement",
      isChecked: true,
      type: "basic",
    },
    {
      name: "Product consumption",
      slug: "product",
      isChecked: true,
      type: "basic",
    },
    { name: "Expenses", slug: "expenses", isChecked: true, type: "basic" },
    {
      name: "SMS promotion",
      slug: "smsPromotion",
      isChecked: true,
      type: "basic",
    },
    {
      name: "Online booking app",
      slug: "onlineBookingApp",
      isChecked: true,
      type: "basic",
    },
    {
      name: "Service reminders",
      slug: "serviceReminder",
      isChecked: true,
      type: "basic",
    },

    {
      name: "Membership",
      slug: "membership",
      isChecked: true,
      type: "professional",
    },
    {
      name: "Staff commission",
      slug: "staffCommission",
      isChecked: true,
      type: "professional",
    },
    {
      name: "Staff pay",
      slug: "staffPayroll",
      isChecked: true,
      type: "professional",
    },
    {
      name: "Ledger/cash register",
      slug: "leager",
      isChecked: true,
      type: "professional",
    },
    { name: "Offers", slug: "offers", isChecked: true, type: "professional" },
    {
      name: "Vouchers",
      slug: "vouchers",
      isChecked: true,
      type: "professional",
    },
    { name: "Package", slug: "package", isChecked: true, type: "professional" },
    {
      name: "Vendors management",
      slug: "vendorsManagement",
      isChecked: true,
      type: "professional",
    },
    {
      name: "Purchase orders",
      slug: "purchaseOrders",
      isChecked: true,
      type: "professional",
    },
    { name: "Enquiry", slug: "enquiry", isChecked: true, type: "professional" },
    {
      name: "Roles & Permissions",
      slug: "rolesPermission",
      isChecked: true,
      type: "professional",
    },
    {
      name: "Business analytics",
      slug: "businessAnalytics",
      isChecked: true,
      type: "professional",
    },

    {
      name: "Multiple outlet management",
      slug: "outlets",
      isChecked: true,
      type: "enterprise",
    },
    {
      name: "Outlet admin",
      slug: "outletsAdmin",
      isChecked: true,
      type: "enterprise",
    },
    {
      name: "Customized packages",
      slug: "customizedPackages",
      isChecked: true,
      type: "enterprise",
    },
    {
      name: "Staff performance dashboard",
      slug: "staffPerformanceDashboard",
      isChecked: true,
      type: "enterprise",
    },
    {
      name: "Biometric staff attendance",
      slug: "biometricStaffAttendance",
      isChecked: true,
      type: "enterprise",
    },
    {
      name: "Reward programs",
      slug: "rewardPrograms",
      isChecked: true,
      type: "enterprise",
    },
  ]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setSuccess(false);
      setEr();
    }, 1500);
    return () => clearTimeout(timer);
  });

  useEffect(() => {
    getAccountDetails();
    getAccountInvoices();
    getAccountAllAppointments();
    getAccountTodaysAppointments();
    generateTinyUrl();
    getManagerName();
    getAccountFeaturesList();
    getWhatsappConnectivityStatus();
    getWhatsappCompanyData();
  }, []);

  useEffect(() => {
    const fetchManager = async () => {
      if (userDetails?.accountData && userDetails?.accountData[0]?.parentId) {
        await ApiGet(
          `account/${userDetails?.accountData && userDetails?.accountData[0]?.parentId
          }`
        )
          .then((res) => {
            setManagername(res.data.data[0]?.Name);
          })
          .catch((err) => {
            console.log("err", err);
          });
      }
    };
    fetchManager();
  }, [userDetails?.accountData]);

  // GET /api/setting/transaction-messages/:companyId — Transaction messages are ON only when admin has given permission (API returns enableTransactionMessages === true). Otherwise always OFF.
  useEffect(() => {
    const companyId = userDetails?.accountData?.[0]?.companyId;
    if (!companyId) return;

    const fetchTransactionMessagesSettings = async () => {
      try {
        const res = await ApiGet("setting/transaction-messages/" + companyId);
        const status = res?.data?.status ?? res?.status;
        if (status === 200) {
          const payload = res?.data?.data ?? res?.data;
          setSMSService(payload?.sendtransactionalSmSFeature === true);
          // Only show Transaction messages ON when backend explicitly says admin enabled it
          const enabled = payload && payload.enableTransactionMessages === true;
          setTransactionMessage(!!enabled);
        } else {
          setTransactionMessage(false);
        }
      } catch (err) {
        console.log("error loading transaction-messages settings", err);
        setTransactionMessage(false);
      }
    };
    fetchTransactionMessagesSettings();
  }, [userDetails?.accountData]);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        let res = await ApiGet(
          "setting/company/" + userDetails?.accountData[0]?.companyId
        );
        if (res.data.status === 200) {
          setSettingId(res.data.data[0]?._id);
        }
      } catch (err) {
        console.log("error while getting Forum", err);
      }
    };
    fetchSettings();
  }, [userDetails?.accountData]);

  // useEffect(async () => {
  //   await ApiGet(
  //     "appointment/company/" + userDetails?.accountData[0]?.companyId
  //   )
  //     .then((res) => {
  //       setTotalAppointment(res?.data?.data?.length);
  //     })
  //     .catch((err) => {
  //       console.log("err", err);
  //     });
  // }, []);

  useEffect(() => {
    const fetchAppointments = async () => {
      let apiDataAppointment = {
        starttime: moment().format("YYYY-MM-DD"),
      };
      await ApiPost(
        "dashboard/company/apointment/" + userDetails?.accountData[0]?.companyId,
        apiDataAppointment
      )
        .then((res) => {
          setTodayAppointment(res?.data?.data?.length);
        })
        .catch((err) => {
          console.log("err", err);
        });
    };
    fetchAppointments();
  }, [userDetails?.accountData]);

  const handleExportCustomer = async () => {

    await ApiGet("customer/company/userdata/" + userDetails?.accountData[0]?.companyId)
      .then((res) => {
        let customerDownloadData = res?.data?.data || [];
        downloadExcel(customerDownloadData, `${userDetails?.accountData[0]?.businessName} Customers`);
        setSuccess(!success);
        setToastmsg(`${userDetails?.accountData[0]?.businessName} Data Downloaded`);
      })
      .catch((err) => {
        console.log("err", err);
      });


  };

  const userPlanDetails =
    userDetails?.monetize?.length > 0
      ? userDetails?.monetize[0]?.paymentData?.length > 0
        ? userDetails?.monetize[0]?.paymentData[
        userDetails?.monetize[0]?.paymentData?.length - 1
        ]
        : null
      : null;

  const DeleteUsermodal = (data) => {
    setDeleteData(data);
    setOpenDeletemodal(!openDeletemodal);
    if (data === true) {
      toggle(true);
      setDeleteData();
    }
  };

  const ActiveUsermodal = (data) => {
    setActiveData(data);
    setOpenDeletemodal(!openDeletemodal);
    if (data === true) {
      setActiveData();
      toggle(false);
    }
  };

  const whatsappValidityModalToggle = () => {
    setWhatsappValidityModal(!whatsappValidityModal);
  };

  const whatsappPaymentDataModalToggle = () => {
    setWhatsappPaymentDataModal(!whatsappPaymentDataModal);
  };

  const getAccountDetails = async () => {
    await ApiGet("customer/company/count/" + userDetails?.accountData[0]?.companyId)
      .then((res) => {
        setTotalCustomer(res?.data?.data);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getAccountInvoices = async () => {
    await ApiGet("invoice/count/" + userDetails?.accountData[0]?.companyId)
      .then((res) => {

        setTotalInvoice(res?.data?.data);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const SMStoggle = async (data) => {
    setSMSServiceSure(!smsServiceSure);
    if (data === true) {
      setisLoading(true);
      const companyId = userDetails?.accountData[0]?.companyId;
      const newSmsEnabled = !smsService;

      try {
        const res = await ApiPut("setting/transaction-messages", {
          companyId,
          sendtransactionalSmSFeature: newSmsEnabled,
        });
        const status = res?.data?.status ?? res?.status;
        if (status === 200) {
          setSuccess(!success);
          setToastmsg(`SMS ${smsService ? "Deactivated" : "Activated"}`);
          setSMSService(newSmsEnabled);
        } else {
          setEr(true);
          setToastmsg(res?.data?.message || "Failed to update SMS");
          setSuccess(true);
        }
      } catch (err) {
        setEr(true);
        setToastmsg(err?.response?.data?.message || err?.message || "Failed to update SMS");
        setSuccess(true);
      }
      setisLoading(false);
    }
  };

  const openTransactionMessageConfirm = () => {
    transactionMessagePreviousRef.current = transactionMessage;
    transactionMessagePendingRef.current = !transactionMessage;
    setTransactionMessageSure(true);
  };

  const TransactionMessageToggle = async (data) => {
    setTransactionMessageSure(false);
    const previous = transactionMessagePreviousRef.current;
    const pendingValue = transactionMessagePendingRef.current;

    if (data === true) {
      setisLoading(true);
      const companyId = userDetails?.accountData[0]?.companyId;
      const newEnabled = pendingValue;

      try {
        const res = await ApiPut("setting/transaction-messages", {
          companyId,
          enableTransactionMessages: newEnabled,
        });
        const status = res?.data?.status ?? res?.status;
        if (status === 200) {
          setTransactionMessage(newEnabled);
          setSuccess(!success);
          setToastmsg(`Transaction Messages ${newEnabled ? "Enabled" : "Disabled"}`);
        } else {
          setTransactionMessage(previous);
          setEr(true);
          setToastmsg(res?.data?.message || "Failed to update");
          setSuccess(true);
        }
      } catch (err) {
        setTransactionMessage(previous);
        setEr(true);
        setToastmsg(err?.response?.data?.message || err?.message || "Failed to update transaction messages");
        setSuccess(true);
      }
      setisLoading(false);
    } else {
      // user cancelled - no state change (transactionMessage was never toggled)
    }
  };

  const getAccountAllAppointments = async () => {
    await ApiGet(
      "appointment/count/" + userDetails?.accountData[0]?.companyId
    )
      .then((res) => {
        setTotalAppointment(res?.data?.data);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getAccountTodaysAppointments = async () => {
    let apiDataAppointment = {
      starttime: moment(new Date()).format("YYYY-MM-DD"),
    };
    await ApiPost(
      "dashboard/company/apointment/" + userDetails?.accountData[0]?.companyId,
      apiDataAppointment
    )
      .then((res) => {
        setTodayAppointment(res?.data?.data?.length);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const generateTinyUrl = async () => {
    let url = {
      link: `https://bookings.barbera.io/?ID=${userDetails?.accountData[0]?.companyId}`,
    };
    await ApiPost(`campaign/company/tinyURl`, url)
      .then((res) => {
        setTinyUrl(res?.data?.data);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getManagerName = async () => {
    if (userDetails?.accountData && userDetails?.accountData[0]?.parentId) {
      await ApiGet(
        `account/${userDetails?.accountData && userDetails?.accountData[0]?.parentId
        }`
      )
        .then((res) => {
          setManagername(res.data.data[0]?.Name);
        })
        .catch((err) => {
          console.log("err", err);
        });
    }
  };

  const getAccountFeaturesList = async () => {
    await ApiGet(`features/company/${userDetails?.accountData[0]?.companyId}`)
      .then((res) => {
        let tempFeaturesData = res.data.data[0];
        setFeaturesData(tempFeaturesData);
        setFeaturesLists((prev) =>
          prev?.map((data) => {
            return { ...data, isChecked: tempFeaturesData?.[data?.slug] };
          })
        );
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getWhatsappConnectivityStatus = async () => {
    let statusPayload = {
      companyId: userDetails?.accountData[0]?.companyId,
    };
    await ApiPost("whatapp/company/connect/status", statusPayload)
      .then((res) => {
        if (res?.data?.data?.length > 0) {
          if (res?.data?.data?.[0]?.isWhatsappConnected) {
            setWhatsappConnectivityStatus("Connected");
          } else {
            setWhatsappConnectivityStatus("Disconnected");
          }
        } else {
          setWhatsappConnectivityStatus("Not Connected");
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getWhatsappCompanyData = async () => {
    await ApiGet(
      `whatappPlan/company/${userDetails?.accountData[0]?.companyId}`
    )
      .then(async (res) => {
        console.log(
          "whatsappRemainingDaysRes res?.data?.data",
          res?.data?.data,
          res?.data?.data?.[0]?.paymentData?.length
        );
        if (res?.data?.data?.length > 0) {
          let whatsappRemainingDaysRes = await ApiGet(
            `whatappPlan/company/remainingDays/${userDetails?.accountData[0]?.companyId}`
          );
          console.log(
            "whatsappRemainingDaysRes",
            whatsappRemainingDaysRes?.data?.data
          );
          if (whatsappRemainingDaysRes?.data?.data) {
            setWhatsappRemainingDays(
              whatsappRemainingDaysRes?.data?.data?.differnce
            );

            setWhatsappPlan(res?.data?.data[0]);
            if (res?.data?.data?.[0]?.paymentData?.length === 0) {
              if (!whatsappRemainingDaysRes?.data?.data?.differnce) {
                setWhatsappPaymentStatus("Trial Expired!");
              } else {
                setWhatsappPaymentStatus("Trial");
              }
            } else {
              if (!whatsappRemainingDaysRes?.data?.data?.differnce) {
                setWhatsappPaymentStatus("Subscription Expired!");
              } else {
                setWhatsappPaymentStatus("Paid");
              }
            }
          } else {
            setWhatsappPaymentStatus("Not Subscribed");
          }
        } else {
          setWhatsappPaymentStatus("Not Subscribed");
        }
      })
      .catch((err) => console.log(err));
  };

  const userValidityAdd = (data) => {
    setAddValidityModal(!addValidityModal);
    if (data === true) {
      toggle("validity");
    }
  };

  const AccountUpgrademodal = (data) => {
    setAccountUpgradeModal(!accountUpgradeModal);
    if (data === true) {
      toggle("upgrade");
    }
  };

  const featuresModalToggle = (data) => {
    setFeaturesModal(!featuresModal);
  };

  const importInventoryModalToggle = () => {
    setImportInventoryModal(!importInventoryModal);
  };

  return (
    <>
      {isLoading && <Loader />}
      <div className="user-information-modal-wrapper">
        <div className="full-page-header-alignment">
          <div className="header-title">
            <div onClick={() => toggle()}>
              <img src={RightIcon} alt="RightIcon" />
            </div>
            <h2>{userDetails?.accountData[0]?.businessName}</h2>
          </div>
          <div className="blue-outline-button">
            {userInformation?.role === "SuperAdmin" && (
              <>
                <button
                  onClick={() => {
                    EdituserModal(userDetails?.accountData[0]);
                    toggle();
                  }}
                >
                  Edit
                </button>
                <button onClick={() => setFeaturesModal(!featuresModal)}>Features</button>
              </>
            )}
            <button onClick={() => userValidityAdd()}>Add validity</button>
          </div>
        </div>
        <div className="full-body-page-top-alignment">
          <div className="user-information-container">
            <div className="grid">
              <div className="grid-items">
                {userInformation?.role === "Manager" &&
                  (userDetails?.noOfDays === 0 ||
                    (userDetails?.monetize?.length
                      ? (userDetails?.monetize && userDetails?.monetize[0]?.paymentData?.length === 0) || userDetails?.noOfDays < 10
                      : userDetails?.monetize?.length === 0)) && (
                    <div className="first-section-alignment">
                      <div className="icon-text-alignment" onClick={() => AccountUpgrademodal()}>
                        <div>
                          <img src={Icon1} alt="Icon1" />
                        </div>
                        <div>
                          <span className="managerasPaid">Mark as paid</span>
                        </div>
                      </div>
                    </div>
                  )}
                {userInformation?.role !== "Manager" && (
                  <>
                    <div className="first-section-alignment">
                      <div className="icon-text-alignment" onClick={() => setSMSServiceSure(!smsServiceSure)}>
                        <div>
                          <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M13.5476 22.75H9.45259C8.92397 22.75 8.46659 22.3821 8.35347 21.8658L7.89559 19.7463C7.28477 19.4786 6.70559 19.144 6.16872 18.7484L4.10209 19.4065C3.59809 19.5672 3.0502 19.3551 2.78584 18.8969L0.733841 15.352C0.472378 14.8936 0.562457 14.3153 0.950966 13.9581L2.55409 12.4956C2.48119 11.8331 2.48119 11.1646 2.55409 10.5021L0.950966 9.043C0.561885 8.68566 0.47177 8.10669 0.733841 7.648L2.78134 4.10088C3.0457 3.64266 3.59359 3.43053 4.09759 3.59125L6.16422 4.24938C6.43879 4.04593 6.72462 3.85813 7.02034 3.68688C7.30422 3.52678 7.59638 3.38183 7.89559 3.25262L8.35459 1.13538C8.46717 0.618965 8.92405 0.250556 9.45259 0.25H13.5476C14.0761 0.250556 14.533 0.618965 14.6456 1.13538L15.1091 3.25375C15.425 3.39271 15.7326 3.54972 16.0305 3.724C16.3083 3.88466 16.5768 4.06082 16.8348 4.25163L18.9026 3.5935C19.4063 3.43338 19.9535 3.64543 20.2177 4.10312L22.2652 7.65025C22.5267 8.10867 22.4366 8.68695 22.0481 9.04412L20.445 10.5066C20.5179 11.1691 20.5179 11.8376 20.445 12.5001L22.0481 13.9626C22.4366 14.3198 22.5267 14.8981 22.2652 15.3565L20.2177 18.9036C19.9535 19.3613 19.4063 19.5734 18.9026 19.4132L16.8348 18.7551C16.5732 18.9478 16.3013 19.1262 16.0203 19.2895C15.7254 19.4604 15.4212 19.6148 15.1091 19.7519L14.6456 21.8658C14.5326 22.3817 14.0758 22.7496 13.5476 22.75ZM6.57259 16.2576L7.49509 16.9326C7.70305 17.0858 7.91979 17.2267 8.14422 17.3545C8.35538 17.4768 8.5728 17.5879 8.79559 17.6875L9.84522 18.1476L10.3593 20.5H12.6431L13.1572 18.1465L14.2068 17.6864C14.6651 17.4843 15.1 17.2331 15.504 16.9371L16.4276 16.2621L18.7237 16.9934L19.8656 15.0156L18.0847 13.3923L18.2107 12.2537C18.2661 11.7558 18.2661 11.2532 18.2107 10.7552L18.0847 9.61675L19.8667 7.99L18.7237 6.01112L16.4276 6.74237L15.504 6.06738C15.0999 5.77005 14.665 5.51697 14.2068 5.3125L13.1572 4.85238L12.6431 2.5H10.3593L9.84297 4.8535L8.79559 5.3125C8.57262 5.41042 8.35517 5.52046 8.14422 5.64213C7.92117 5.76962 7.70557 5.90972 7.49847 6.06175L6.57484 6.73675L4.27984 6.0055L3.13572 7.99L4.91659 9.61112L4.79059 10.7507C4.73524 11.2487 4.73524 11.7513 4.79059 12.2493L4.91659 13.3878L3.13572 15.0111L4.27759 16.9889L6.57259 16.2576ZM11.4956 16C9.01031 16 6.99559 13.9853 6.99559 11.5C6.99559 9.01472 9.01031 7 11.4956 7C13.9809 7 15.9956 9.01472 15.9956 11.5C15.9925 13.984 13.9796 15.9969 11.4956 16ZM11.4956 9.25C10.2664 9.25125 9.26571 10.2387 9.2481 11.4678C9.23049 12.6968 10.2025 13.7125 11.4311 13.749C12.6598 13.7855 13.6903 12.8292 13.7456 11.6012V12.0512V11.5C13.7456 10.2574 12.7382 9.25 11.4956 9.25Z"
                              fill="#1479ff"
                            />
                          </svg>
                        </div>
                        <div>
                          <span>{smsService ? "Deactivate" : "Activate"} SMS service</span>
                        </div>
                      </div>
                      <div
                        className="icon-text-alignment"
                        onClick={() => {
                          setSuccess(!success);
                          setToastmsg("Coming soon!");
                          setEr("error");
                        }}
                      >
                        <div>
                          <img src={Icon1} alt="Icon1" />
                        </div>
                        <div>
                          <span>Import services</span>
                        </div>
                      </div>
                      <div
                        className="icon-text-alignment"
                        onClick={() => {
                          setSuccess(!success);
                          setToastmsg("Coming soon!");
                          setEr("error");
                        }}
                      >
                        <div>
                          <img src={UserIcon} alt="Icon1" />
                        </div>
                        <div>
                          <span>Import customers</span>
                        </div>
                      </div>
                      {totalCustomer > 0 && (
                        <div className="icon-text-alignment" onClick={handleExportCustomer}>
                          <div>
                            <img src={UserIcon} alt="Icon1" />
                          </div>
                          <div>
                            <span>Export customers</span>
                          </div>
                        </div>
                      )}
                      <div
                        className="icon-text-alignment"
                        onClick={() => importInventoryModalToggle()}
                      >
                        <div>
                          <img src={BoxIcon} alt="Icon1" />
                        </div>
                        <div>
                          <span>Import inventory</span>
                        </div>
                      </div>
                      <div
                        className="icon-text-alignment"
                        style={{ border: "none" }}
                        onClick={openTransactionMessageConfirm}
                      >
                        <div>
                          <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M13.5476 22.75H9.45259C8.92397 22.75 8.46659 22.3821 8.35347 21.8658L7.89559 19.7463C7.28477 19.4786 6.70559 19.144 6.16872 18.7484L4.10209 19.4065C3.59809 19.5672 3.0502 19.3551 2.78584 18.8969L0.733841 15.352C0.472378 14.8936 0.562457 14.3153 0.950966 13.9581L2.55409 12.4956C2.48119 11.8331 2.48119 11.1646 2.55409 10.5021L0.950966 9.043C0.561885 8.68566 0.47177 8.10669 0.733841 7.648L2.78134 4.10088C3.0457 3.64266 3.59359 3.43053 4.09759 3.59125L6.16422 4.24938C6.43879 4.04593 6.72462 3.85813 7.02034 3.68688C7.30422 3.52678 7.59638 3.38183 7.89559 3.25262L8.35459 1.13538C8.46717 0.618965 8.92405 0.250556 9.45259 0.25H13.5476C14.0761 0.250556 14.533 0.618965 14.6456 1.13538L15.1091 3.25375C15.425 3.39271 15.7326 3.54972 16.0305 3.724C16.3083 3.88466 16.5768 4.06082 16.8348 4.25163L18.9026 3.5935C19.4063 3.43338 19.9535 3.64543 20.2177 4.10312L22.2652 7.65025C22.5267 8.10867 22.4366 8.68695 22.0481 9.04412L20.445 10.5066C20.5179 11.1691 20.5179 11.8376 20.445 12.5001L22.0481 13.9626C22.4366 14.3198 22.5267 14.8981 22.2652 15.3565L20.2177 18.9036C19.9535 19.3613 19.4063 19.5734 18.9026 19.4132L16.8348 18.7551C16.5732 18.9478 16.3013 19.1262 16.0203 19.2895C15.7254 19.4604 15.4212 19.6148 15.1091 19.7519L14.6456 21.8658C14.5326 22.3817 14.0758 22.7496 13.5476 22.75ZM6.57259 16.2576L7.49509 16.9326C7.70305 17.0858 7.91979 17.2267 8.14422 17.3545C8.35538 17.4768 8.5728 17.5879 8.79559 17.6875L9.84522 18.1476L10.3593 20.5H12.6431L13.1572 18.1465L14.2068 17.6864C14.6651 17.4843 15.1 17.2331 15.504 16.9371L16.4276 16.2621L18.7237 16.9934L19.8656 15.0156L18.0847 13.3923L18.2107 12.2537C18.2661 11.7558 18.2661 11.2532 18.2107 10.7552L18.0847 9.61675L19.8667 7.99L18.7237 6.01112L16.4276 6.74237L15.504 6.06738C15.0999 5.77005 14.665 5.51697 14.2068 5.3125L13.1572 4.85238L12.6431 2.5H10.3593L9.84297 4.8535L8.79559 5.3125C8.57262 5.41042 8.35517 5.52046 8.14422 5.64213C7.92117 5.76962 7.70557 5.90972 7.49847 6.06175L6.57484 6.73675L4.27984 6.0055L3.13572 7.99L4.91659 9.61112L4.79059 10.7507C4.73524 11.2487 4.73524 11.7513 4.79059 12.2493L4.91659 13.3878L3.13572 15.0111L4.27759 16.9889L6.57259 16.2576ZM11.4956 16C9.01031 16 6.99559 13.9853 6.99559 11.5C6.99559 9.01472 9.01031 7 11.4956 7C13.9809 7 15.9956 9.01472 15.9956 11.5C15.9925 13.984 13.9796 15.9969 11.4956 16ZM11.4956 9.25C10.2664 9.25125 9.26571 10.2387 9.2481 11.4678C9.23049 12.6968 10.2025 13.7125 11.4311 13.749C12.6598 13.7855 13.6903 12.8292 13.7456 11.6012V12.0512V11.5C13.7456 10.2574 12.7382 9.25 11.4956 9.25Z"
                              fill="#1479ff"
                            />
                          </svg>
                        </div>
                        <div>
                          <span>{transactionMessage ? "Disable" : "Enable"} Transaction Messages</span>
                        </div>
                      </div>
                    </div>
                    <div className="first-section-alignment">
                      {(userDetails?.noOfDays === 0 ||
                        (userDetails?.monetize?.length
                          ? userDetails?.monetize[0]?.paymentData?.length === 0 || userDetails?.noOfDays < 30
                          : userDetails?.monetize?.length === 0)) && (
                          <div className="icon-text-alignment" onClick={() => setAccountUpgradeModal(!accountUpgradeModal)}>
                            <div>
                              <img src={MarkIcon} alt="Icon1" />
                            </div>
                            <div>
                              <span>Mark as paid</span>
                            </div>
                          </div>
                        )}
                      {userDetails?.accountData[0]?.isActive ? (
                        <div className="icon-text-alignment red-icon-align" onClick={() => DeleteUsermodal(userDetails)}>
                          <div>
                            <img src={CrossIcon} alt="DeleteIcon" />
                          </div>
                          <div>
                            <span>Deactivate account</span>
                          </div>
                        </div>
                      ) : (
                        <div className="icon-text-alignment " style={{ border: "none" }} onClick={() => ActiveUsermodal(userDetails)}>
                          <div>
                            <img src={MarkIcon} alt="DeleteIcon" />
                          </div>
                          <div>
                            <span>Activate account</span>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="first-section-alignment">
                      {/* {(userDetails?.noOfDays == 0 ||
                        (userDetails?.monetize?.length
                          ? userDetails?.monetize[0]?.paymentData?.length == 0
                          : userDetails?.monetize?.length == 0)) && ( */}

                      {whatsappPlan === undefined ? (
                        ""
                      ) : whatsappPlan?.paymentData?.length === 0 || whatsappRemainingDays === 0 ? (
                        <div className="icon-text-alignment" onClick={() => whatsappPaymentDataModalToggle()}>
                          <div>
                            <img src={WhatsappIcon} alt="WhatsappIcon" />
                          </div>
                          <div>
                            <span>Whatsapp payment</span>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                      {/* // )} */}

                      {whatsappPlan?.paymentData?.length === 0 && (
                        <div className="icon-text-alignment" onClick={() => whatsappValidityModalToggle()}>
                          <div>
                            <img src={CalendarIcon} alt="CalendarIcon " />
                          </div>
                          <div>
                            <span>Add validity (WhatsApp)</span>
                          </div>
                        </div>
                      )}
                    </div>
                  </>
                )}
              </div>
              <div className="grid-items">
                <div className="all-data-style-alignment">
                  <div className="box-title">
                    <h5>Account data</h5>
                  </div>
                  <div className="all-text-grid-alignment">
                    <div className="text-grid">
                      <div className="text-grid-items">
                        <span>Salon name</span>
                      </div>
                      <div className="text-grid-items">
                        <p>{userDetails?.accountData[0]?.businessName}</p>
                      </div>
                    </div>
                    <div className="text-grid">
                      <div className="text-grid-items">
                        <span>Owner name</span>
                      </div>
                      <div className="text-grid-items">
                        <p>{userDetails?.accountData[0]?.nameOfSalonOwner}</p>
                      </div>
                    </div>
                    <div className="text-grid">
                      <div className="text-grid-items">
                        <span>Mobile number</span>
                      </div>
                      <div className="text-grid-items">
                        <p>+{userDetails?.accountData[0]?.dialCode} {userDetails?.accountData[0]?.mobileNumber}</p>
                      </div>
                    </div>
                    <div className="text-grid">
                      <div className="text-grid-items">
                        <span>Email</span>
                      </div>
                      <div className="text-grid-items">
                        <p>{userDetails?.accountData[0]?.email}</p>
                      </div>
                    </div>
                    {userInformation?.role === "SuperAdmin" && (
                      <div className="text-grid">
                        <div className="text-grid-items">
                          <span>Password</span>
                        </div>
                        <div className="text-grid-items">
                          <p>{userDetails?.accountData[0]?.password}</p>
                        </div>
                      </div>
                    )}
                    <div className="text-grid">
                      <div className="text-grid-items">
                        <span>Salon address</span>
                      </div>
                      <div className="text-grid-items">
                        <p>{userDetails?.accountData[0]?.address} </p>
                      </div>
                    </div>
                    <div className="text-grid">
                      <div className="text-grid-items">
                        <span>Account validity</span>
                      </div>
                      <div className="text-grid-items">
                        <p>{userDetails?.noOfDays} days </p>
                      </div>
                    </div>
                    {!!userPlanDetails?.planId?.planName && (
                      <>
                        <div className="text-grid">
                          <div className="text-grid-items">
                            <span>Current plan</span>
                          </div>
                          <div className="text-grid-items">
                            <p>{userPlanDetails?.planId?.planName} </p>
                          </div>
                        </div>
                        {userPlanDetails?.planId?.planName === "Pro" || userPlanDetails?.planId?.planName === "Barbera Pro"
                          ? featuresLists?.filter((data) => data?.type === "enterprise" && data?.isChecked)?.length > 0 && (
                            <div className="text-grid">
                              <div className="text-grid-items">
                                <span>Add ons</span>
                              </div>
                              <div className="text-grid-items">
                                <p>
                                  {featuresLists
                                    ?.reduce((a, b) => {
                                      if (b?.type === "enterprise" && b?.isChecked) {
                                        return [...a, b?.name];
                                      } else {
                                        return a;
                                      }
                                    }, [])
                                    ?.join(", ")}
                                </p>
                              </div>
                            </div>
                          )
                          : userPlanDetails?.planId?.planName === "Basic"
                            ? featuresLists?.filter((data) => (data?.type === "enterprise" || data?.type === "professional") && data?.isChecked)
                              ?.length > 0 && (
                              <div className="text-grid">
                                <div className="text-grid-items">
                                  <span>Add ons</span>
                                </div>
                                <div className="text-grid-items">
                                  <p>
                                    {featuresLists
                                      ?.reduce((a, b) => {
                                        if ((b?.type === "professional" || b?.type === "enterprise") && b?.isChecked) {
                                          return [...a, b?.name];
                                        } else {
                                          return a;
                                        }
                                      }, [])
                                      ?.join(", ")}
                                  </p>
                                </div>
                              </div>
                            )
                            : ""}
                      </>
                    )}
                    <div className="text-grid">
                      <div className="text-grid-items">
                        <span>Account manager</span>
                      </div>
                      <div className="text-grid-items">
                        <p>{managername ? managername : "None"}</p>
                      </div>
                    </div>
                    <div className="text-grid">
                      <div className="text-grid-items">
                        <span>Account status</span>
                      </div>
                      <div className="text-grid-items">
                        <p>{userDetails?.accountData[0]?.isActive ? "Active" : "Deactivated"}</p>
                      </div>
                    </div>
                    <div className="text-grid">
                      <div className="text-grid-items">
                        <span>Payment status</span>
                      </div>
                      <div className="text-grid-items">
                        <p>
                          {userDetails?.noOfDays === 0 ||
                            (userDetails?.monetize?.length
                              ? userDetails?.monetize && userDetails?.monetize[0]?.paymentData?.length === 0
                              : userDetails?.monetize?.length === 0)
                            ? "Unpaid"
                            : "Paid"}
                        </p>
                      </div>
                    </div>
                    <div className="text-grid">
                      <div className="text-grid-items">
                        <span>Customer booking link</span>
                      </div>
                      <div className="text-grid-items">
                        <p>
                          <a target="_BLANK" rel="noreferrer" href={`${tinyUrl}`}>
                            {tinyUrl}
                          </a>
                        </p>
                        <div className="paid-button-style">
                          <button onClick={() => navigator.clipboard.writeText(tinyUrl)}>Copy URL</button>
                        </div>
                      </div>
                    </div>
                    {/* asa */}
                  </div>
                  <div className="box-title sub-total-top-alignment">
                    <h5>WhatsApp</h5>
                  </div>
                  <div className="all-text-grid-alignment">
                    <div className="text-grid">
                      <div className="text-grid-items">
                        <span>Status</span>
                      </div>
                      {!whatsappConnectivityStatus ? (
                        <Skeleton />
                      ) : (
                        <div className="text-grid-items">
                          <p>{whatsappConnectivityStatus}</p>
                        </div>
                      )}
                    </div>
                    <div className="text-grid">
                      <div className="text-grid-items">
                        <span>Payment</span>
                      </div>
                      {!whatsappPaymentStatus ? (
                        <Skeleton />
                      ) : (
                        <div className="text-grid-items">
                          <p> {whatsappPaymentStatus}</p>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="box-title sub-total-top-alignment">
                    <h5>Analytics</h5>
                  </div>
                  <div className="all-text-grid-alignment">
                    <div className="text-grid">
                      <div className="text-grid-items">
                        <span>Total appointments booked</span>
                      </div>
                      <div className="text-grid-items">
                        <p>
                          {totalAppointment} ({todayAppointment})
                        </p>
                      </div>
                    </div>
                    <div className="text-grid">
                      <div className="text-grid-items">
                        <span>Total invoices generated</span>
                      </div>
                      <div className="text-grid-items">
                        <p>
                          {totalInvoice}
                          {/* ({todayInvoice}) */}
                        </p>
                      </div>
                    </div>
                    <div className="text-grid">
                      <div className="text-grid-items">
                        <span>Total customers added</span>
                      </div>
                      <div className="text-grid-items">
                        <p>{totalCustomer}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* account validity */}
      {addValidityModal && (
        <AddValidity
          toggle={userValidityAdd}
          addValidityModal={addValidityModal}
          setAddValidityModal={setAddValidityModal}
          userDetails={userDetails}
        />
      )}

      {whatsappValidityModal && (
        <AddWhatsaooValidity
          toggle={whatsappValidityModalToggle}
          whatsappRemainingDays={whatsappRemainingDays}
          whatsappPlan={whatsappPlan}
          getWhatsappCompanyData={getWhatsappCompanyData}
        />
      )}
      {whatsappPaymentDataModal && (
        <WhatsappPayment
          toggle={whatsappPaymentDataModalToggle}
          whatsappRemainingDays={whatsappRemainingDays}
          userDetails={userDetails}
          getWhatsappCompanyData={getWhatsappCompanyData}
          whatsappPlan={whatsappPlan}
          userInformation={userInformation}
        />
      )}

      {accountUpgradeModal && <AccountUpgrade toggle={AccountUpgrademodal} userDetails={userDetails} />}
      {featuresModal && (
        <Features
          toggle={featuresModalToggle}
          getAccountFeaturesList={getAccountFeaturesList}
          userDetails={userDetails}
          userPlanDetails={userPlanDetails}
          featuresLists={featuresLists}
          setFeaturesLists={setFeaturesLists}
          featuresData={featuresData}
          setSuccess={setSuccess}
          setToastmsg={setToastmsg}
          setEr={setEr}
        />
      )}
      {openDeletemodal && <Delete toggle={DeleteUsermodal} deleteData={deleteData} activeData={activeData} />}
      {success && <Success modal={success} toastmsg={toastmsg} er={er} />}
      {smsServiceSure && <AcceptDeny modal={smsServiceSure} toggle={SMStoggle} type={smsService} label="SMS" />}
      {transactionMessageSure && (
        <AcceptDeny
          modal={transactionMessageSure}
          toggle={TransactionMessageToggle}
          type={transactionMessage}
          label="Transaction messages"
          message={
            transactionMessagePendingRef.current
              ? "Enable transaction messages?"
              : "Disable transaction messages?"
          }
        />
      )}
      {importInventoryModal && (
        <ImportInventoryModal
          toggle={importInventoryModalToggle}
          companyId={userDetails?.accountData?.[0]?.companyId}
        />
      )}
    </>
  );
}
